



import Image from 'next/image';
import React, { useState } from 'react';
import { carretDown } from '../../../public/assets/icons';
import styles from './select.module.scss';

const DropDown = ({ options, selected, setSelected, value, setValue, error }) => {
  const [active, setActive] = useState(false);

  return (
    <section
      className={[
        styles.dropdown,
        `${error ? 'bg-error-light' : 'bg-light-input'}`,
      ].join(' ')}
    >
      <div
        className={styles.dropdown_btn}
        onClick={() => setActive((prev) => !prev)}
      >
        <div>{selected || <span className="text-neutral-mid-60">Select...</span>}</div>
        <div
          className={`${
            active ? 'rotate-180' : ''
          } transition-all duration-200 ease-linear`}
        >
          <Image src={carretDown} alt="carret" />
        </div>
      </div>

      {active && (
        <div className={styles.dropdown_content}>
          {options.length === 0 ? <h2>No Items to Display</h2> : null}
          {options &&
            options.map((option, idx) => (
              <div
                className={styles.dropdown_item}
                key={idx}
                onClick={() => {
                  setSelected(option.label); // Update selected label
                  setActive(false);
                  setValue(option.value); // Update selected value
                }}
              >
                {option.label}
              </div>
            ))}
        </div>
      )}
    </section>
  );
};

export default DropDown;




// import Image from 'next/image';
// import React, { useState } from 'react';
// import { carretDown } from '../../../public/assets/icons';
// import styles from './select.module.scss';
// // import Select from 'react-select';

// const DropDown = ({
//   options,
//   selected,
//   setSelected,
//   value,
//   setValue,
//   error,
// }) => {
//   const [active, setActive] = useState(false);

//   return (
//     <section
//       className={[
//         styles.dropdown,
//         `${error ? ' bg-error-light' : 'bg-light-input'}`,
//       ].join(' ')}
//     >
//       <div
//         className={styles.dropdown_btn}
//         onClick={() => setActive(prev => !prev)}
//       >
//         <div>
//           {selected || <span className="text-neutral-mid-60">Select...</span>}
//         </div>
//         <div
//           className={`${
//             active ? 'rotate-180' : null
//           } transition-all duration-200 ease-linear`}
//         >
//           <Image src={carretDown} alt="carret" />
//         </div>
//       </div>

//       {active && (
//         <div className={styles.dropdown_content}>
//           {options.length === 0 ? <h2>No Items to Display</h2> : null}
//           {options &&
//             options.map((option, idx) => (
//               <div
//                 className={styles.dropdown_item}
//                 key={idx}
//                 onClick={e => {
//                   setSelected(e.target.textContent);
//                   setActive(false);
//                   setValue(option.value);
//                 }}
//               >
//                 {option.label}
//               </div>
//             ))}
//         </div>
//       )}
//     </section>
//   );
// };

// export default DropDown;